import OldPrivacyPolicy from '../scripts/views/OldPrivacyPolicy';

export default OldPrivacyPolicy;
